export const InternSatisfactionFormFormat = function (blueprint, form_data = {}) {
  return {
    header_sq: header(form_data),
    content_sq: page(blueprint, form_data),
  };
}
function header(form_data) {
  return [
    {
      w: '100%', h: 50, text: '國立臺灣科技大學校外實習問卷調查表',
      border_width: 0, font_size: 21, font_family: '標楷體',
    },
  ];
}

function page(blueprint, form_data) {
  return [
    { w: '100%', h: 190, not_take_space: true },
    {
      w: '100%', h: 30, padding: 10, text: '業界先進 您好：',
      border_width: 0, align: 'left', font_family: '標楷體',
    },
    {
      w: '100%', h: 130, padding: 30, text: '　　感謝貴公司提供本校學生實習機會，讓學子們能有學習與成長的經驗。為了解本校學生於貴公司之實習表現與貴公司對本校學生實習的滿意程度，並關心學生實習之狀況，藉由本問卷彙整各機構之意見，作為未來實習課程之安排與參考，您所填寫的資料僅進行整體分析，不涉及個別資料判別，絕不對外公開，敬請安心作答。\n在此致上謝意！\n敬祝  健康如意',
      border_width: 0, align: 'left', font_family: '標楷體',
    },
    {
      w: '100%', h: 30, padding: 10, text: '國立臺灣科技大學 敬啟',
      border_width: 0, align: 'right', font_family: '標楷體',
    },

    {
      w: '100%', h: 30, text: '一、基本資料',
      border_width: 0, align: 'left', font_family: '標楷體',
    },

    { w: '18%', h: 30, text: '公司名稱' },
    { w: '32%', h: 30, text: form_data.enterprise_name },
    { w: '18%', h: 30, text: '填表日期' },
    { w: '32#', h: 30, text: date_to_str_yyyy_mm_dd(form_data.filling_date) },

    { w: '18%', h: 30, text: '實習機構評核者' },
    { w: '32%', h: 30, text: form_data.company_scorer },
    { w: '18%', h: 30, text: '職稱' },
    { w: '32%', h: 30, text: form_data.company_role },

    { w: '18%', h: 30, text: '實習生姓名' },
    { w: '32%', h: 30, text: form_data.student_name },
    { w: '18%', h: 30, text: '就讀系所' },
    { w: '32%', h: 30, text: form_data.department_id },

    { w: '28%', h: 30, text: '實習生職稱或實習內容' },
    { w: '72%', h: 30, text: form_data.intern_content },
    
    { w: '18%', h: 30, text: '實習期間' },
    { w: '82%', h: 30, text: `${date_to_str(form_data.start_time)}～${date_to_str(form_data.end_time)}` },

    {
      w: '100%', h: 30, text: '二、對本校學生整體表現滿意度',
      border_width: 0, align: 'left', font_family: '標楷體',
    },

    { w: '100%', h: 30, not_take_space: true },
    { w: '30%', h: 30, padding: 10, align: 'left', border_width: 0, text: '行政運作' },
    { w: '70%', h: 30, padding: 10, align: 'right', border_width: 0, text: '(非常滿意: 5, 滿意: 4, 尚可: 3, 不滿意: 2, 非常不滿意: 1 )' },

    ...check_radio_table(blueprint.find(block => block.key == 'check').items, form_data.check),

    {
      w: '100%', h: 30, text: '三、其他意見分享',
      border_width: 0, align: 'left', font_family: '標楷體',
    },
    { w: '100%', h: 100, padding: 10, align: 'left', baseline: 'top', text: form_data.opinion_share },
  ];
}

function check_radio_table(items, values) {
  return items.map((item, index) => {
    return [
      { w: '70%', h: 30, padding: 10, align: 'left', text: item },
      { w: '30%', h: 30, padding: 10, texts: values[index] },
    ];
  }).flat();
}

// 通用
function other_str(value) {
  return (value ? '☑': '☐') + ' 其他：' + (value || "____________________");
}
function date_to_str(date_str) {
  if(!date_str) return ' - ';
  let nd = new Date(date_str);
  return `${nd.getFullYear() - 1911} 年 ${nd.getMonth() + 1} 月 ${nd.getDate()} 日`;
}
function date_to_str_yyyy_mm_dd(date_str) {
  if(!date_str) return ' - ';
  let nd = new Date(date_str);
  return [
    nd.getFullYear(),
    ("0" + (nd.getMonth() + 1)).substr(-2),
    ("0" + nd.getDate()).substr(-2),
  ].join('/');
}